// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  jobId: __t.u64().primaryKey().name("job_id"),
  owner: __t.identity(),
  stationKey: __t.string().name("station_key"),
  processKey: __t.string().name("process_key"),
  processVersion: __t.u32().name("process_version"),
  profile: __t.string(),
  runs: __t.u32(),
  inputFamily: __t.string().name("input_family"),
  inputName: __t.string().name("input_name"),
  inputStatsJson: __t.string().name("input_stats_json"),
  inputQty: __t.u32().name("input_qty"),
  ceiling: __t.u32(),
  durationS: __t.u32().name("duration_s"),
  state: __t.string(),
  reservedAt: __t.timestamp().name("reserved_at"),
  startedAt: __t.timestamp().name("started_at"),
  readyAt: __t.timestamp().name("ready_at"),
  endedAt: __t.timestamp().name("ended_at"),
  outputsJson: __t.string().name("outputs_json"),
  note: __t.string(),
});
